import { useQueryGetUserLogged } from '@flecto/core/shared'

export function useUserVerified() {
  const { data: user, isLoading } = useQueryGetUserLogged()

  const isUserOnboarded = Boolean(user?.onboarded_at)

  const isUserVerified = Boolean(user?.meta?.email_verified)

  return { isUserVerified, isUserOnboarded, isLoading }
}
